import React, { forwardRef } from "react";
import classNames from "classnames";

import { useNavigate } from "react-router";
import { useAuth } from "@/hooks/use-auth";
import paths from "@/routes/paths";

const ProfileMenu = forwardRef<HTMLDivElement, any>(
  ({ isActive, list, className, onClose }, ref) => {
    const navigate = useNavigate();
    const auth = useAuth();

    if (!isActive) return null;

    const handleMenuItemClick = (item: any) => {
      if (item.path === paths.logout) {
        auth.logout();
        navigate(paths.root);
      } else {
        navigate(item.path);
      }
      onClose();
    };

    return (
      <div
        ref={ref}
        className={classNames(
          className,
          "border-4 border-dark-1 bg-dark-2 rounded-xl px-6 py-4 flex flex-col gap-y-3 items-start",
        )}
      >
        {list?.map((item: any, index: number) => (
          <div
            role="button"
            onClick={() => handleMenuItemClick(item)}
            aria-label="dropdown-menu"
            key={index + item.path}
            className="flex flex-row gap-x-3 items-center"
          >
            {item.icon}
            <span className="text-xs text-white font-redhat-display font-bold cursor-pointer transition-all duration-300 hover:text-white/50">
              {item.label}
            </span>
          </div>
        ))}
      </div>
    );
  },
);

ProfileMenu.displayName = "ProfileMenu";
export default ProfileMenu;
